import http from './api'

const route = 'registrar/usuarios'

export default {

    listar: () => (
        http.get(route)
    ),

    registrar: (usuario, url) => {
        return http.post(route, {
            usuario: usuario,
            url: url,
        })
    },

    verificaEmpresa: (tokencontrato) => {
        return http.post(route + '/verifica_empresa', {
            tokencontrato: tokencontrato,
        })
    },

    verificaCliente: (username) => {
        return http.post(route + '/verifica_cliente', { username: username })
    },

    ativarUsuario: (link) => {
        return http.post(route + '/ativar_usuario', {
            link: link,
        })
    },
}
